import { Button, FormHelperText, Grid, makeStyles, Typography } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { Field, FieldProps, useFormikContext } from 'formik';
import React, { ChangeEvent } from 'react';
import { LessonForm } from '../types';
import StepContainer from './StepContainer';

const useStyles = makeStyles((theme) => ({
  input: {
    display: 'none',
  },
  buttonError: {
    backgroundColor: theme.palette.error.main,
    color: '#ffffff',

    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

interface Props {
  lessonFile?: File | undefined;
  handleFileUploadChange?: (newFile: File) => void;
}

const UploadForm: React.FC<Props> = ({ lessonFile, handleFileUploadChange }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const fileUploadList = event.currentTarget.files;

    if (fileUploadList && handleFileUploadChange) {
      const newFile = fileUploadList[0];
      handleFileUploadChange(newFile);

      setFieldValue('upload', newFile.name);
      setFieldTouched('upload', true);
    }
  }

  const classes = useStyles();

  return (
    <StepContainer>
      <Grid item>
        <Typography gutterBottom>Upload your lesson:</Typography>
      </Grid>
      <Grid item>
        <FormHelperText>
          Please attach your lesson file here. If you need to export your file from Google Docs, you
          can find those instructions here:
          https://oregonstate.teamdynamix.com/TDClient/KB/ArticleDet?ID=45811
        </FormHelperText>
      </Grid>
      <Field name="upload">
        {({ field, meta: { error, touched } }: FieldProps<LessonForm['upload']>) => {
          let filename = '';

          if (lessonFile) {
            filename = lessonFile.name;
          }

          // Many browsers attach "C:\fakepath\" to the beginning of a file to hide the real filepath
          if (filename.startsWith('C:\\fakepath\\')) {
            filename = filename.substring(12);
          }

          return (
            <Grid direction="column" container item>
              <Grid alignItems="center" spacing={2} container item>
                <Grid item>
                  <input
                    className={classes.input}
                    id="contained-button-file"
                    type="file"
                    onChange={handleChange}
                  />
                  <label htmlFor="contained-button-file">
                    <Button
                      className={touched && Boolean(error) ? classes.buttonError : undefined}
                      variant="contained"
                      color={touched && Boolean(error) ? 'inherit' : 'primary'}
                      startIcon={<CloudUploadIcon />}
                      component="span"
                    >
                      {filename === '' ? 'Upload' : 'Change File'}
                    </Button>
                  </label>
                </Grid>
                <Grid item>
                  <Typography>{filename}</Typography>
                </Grid>
              </Grid>
              {touched && Boolean(error) && (
                <Grid item>
                  <FormHelperText error>{error}</FormHelperText>
                </Grid>
              )}
            </Grid>
          );
        }}
      </Field>
    </StepContainer>
  );
};

export default UploadForm;
